interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact "chart-simple" asset from the Create-menu Figma dropdown. */
const FigmaChartIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 16H6V1.33333C6 0.6 6.6 0 7.33333 0H8.66667C9.4 0 10 0.6 10 1.33333V16ZM16 16H12V5.33333C12 4.6 12.6 4 13.3333 4H14.6667C15.4 4 16 4.6 16 5.33333V16ZM4 16H0V9.33333C0 8.6 0.6 8 1.33333 8H2.66667C3.4 8 4 8.6 4 9.33333V16Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaChartIcon;
